import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/promocodes/promocodeController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";

const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);

      const option = {
        isExport : true,
        condition: {
          ...(formData.get("code") && { code: formData.get("code") } ),
          ...(formData.get("title") && { title: { $regex: formData.get("title"), $options: "i" } } ),
          ...(formData.get("points") && { points: parseInt(formData.get("points")) } ),
          ...(formData.get("valid_date") && { valid_date: new Date(formData.get("valid_date")) } ),
          ...(formData.get("expire_date") && { expire_date: new Date(formData.get("expire_date")) } ),
        },
        select: {
          ...(formData.get("select_code") && { code: true } ),
          ...(formData.get("select_title") && { title: true } ),
          ...(formData.get("select_description") && { description: true } ),
          ...(formData.get("select_points") && { points: true } ),
          ...(formData.get("select_valid_date") && { valid_date: true } ),
          ...(formData.get("select_expire_date") && { expire_date: true } ),
        },
      };

      // Make the API call
      const res = await list(option);
      if (res.status === true) {
        await exportToExcel(res.result); // Export the results to Excel
        handleCancel(); // Reset the form or close modal
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    }
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `${new Date()}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Export promocodes
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="code" className="all_lable_for_vendor_dashbaord">Code :</label>
                    <input type="text" name="code" id="code" placeholder="Code" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="title" className="all_lable_for_vendor_dashbaord">Title :</label>
                    <input type="text" name="title" id="title" placeholder="Title" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="valid_date" className="all_lable_for_vendor_dashbaord">Valid Date :</label>
                    <input type="date" name="valid_date" id="valid_date" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="expire_date" className="all_lable_for_vendor_dashbaord">Expire Date :</label>
                    <input type="date" name="expire_date" id="expire_date" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="points" className="all_lable_for_vendor_dashbaord">Points :</label>
                    <input type="number" name="points" id="points" placeholder="Points" className="form-control categories_select_tg_enter_product" />
                  </div>

                  {/* Selection Checkboxes for Export */}
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="select_name" className="all_lable_for_vendor_dashbaord" > Export fields (If any) : </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_code" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_code" id="select_code" className="form-check-input" /> Code
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_title" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_title" id="select_title" className="form-check-input" /> Title
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_description" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_description" id="select_description" className="form-check-input" /> Description
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_points" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_points" id="select_points" className="form-check-input" /> Points
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_valid_date" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_valid_date" id="select_valid_date" className="form-check-input" /> Valid Date
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_expiry_date" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_expire_date" id="select_expire_date" className="form-check-input" /> Expire Date
                      </label>
                    </div>
  

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
